export const isPagePreviewCurrent = (page) => {
  const previewUrl = page?.preview?.url;
  if (!previewUrl) return false;

  const sourceRevision = page.previewSourceRevision;
  if (!sourceRevision) return true;

  return sourceRevision === page.previewAppliedSourceRevision;
};

export const getProjectPreviewState = (pages = []) => {
  const normalizedPages = (Array.isArray(pages) ? pages : [])
    .map((page) => page?.node ?? page)
    .filter(Boolean);

  return {
    urls: normalizedPages
      .filter(isPagePreviewCurrent)
      .map((page) => page.preview.url),
    hasPendingPreview: normalizedPages.some(
      (page) =>
        Boolean(page.previewSourceRevision) &&
        page.previewSourceRevision !== page.previewAppliedSourceRevision
    ),
  };
};

export const getProjectThumbnails = ({
  previewUrls = [],
  gifPreviewId,
  hasPendingPreview = false,
  videoCdnUrl,
  fallbackUrl,
  resizePreview = (url) => url,
  maxPages = 2,
}) => {
  const currentPreviewUrls = Array.isArray(previewUrls) ? previewUrls : [];

  if (currentPreviewUrls.length > 0) {
    return currentPreviewUrls.slice(0, maxPages).map(resizePreview);
  }

  if (gifPreviewId && !hasPendingPreview) {
    return [`${videoCdnUrl}/${gifPreviewId}`];
  }

  return [fallbackUrl];
};
